export default defineAppConfig({
	appConfig:
		process.env.NODE_ENV === "production"
			? {
					apiBaseUrl: "https://api.hakko.ai:8760",
					saBaseUrl: "https://xinyingsuixing.datasink.sensorsjourney.com/",
					test: "production",
					app_version: "1.0.0",
					app_platform: "web",
					device: "",
				}
			: {
					// apiBaseUrl: "https://api.hakko.ai:8760",
					apiBaseUrl: 'https://huoban.ai:8760',
					// apiBaseUrl: "https://api.huoban.ai:8761",
					// saBaseUrl: "/",
					saBaseUrl: "https://xinyingsuixing.datasink.sensorsjourney.com/",
					test: "dev",
					app_version: "1.0.0",
					app_platform: "web",
					device: "",
				},
});
